export enum UniversalIdFields {
    FIRST_NAME = 'firstName',
    LAST_NAME = 'lastName',
    EMAIL = 'email',
    PHONE = 'phoneNumber',
    DOB = 'dateOfBirth',
    USERNAME = 'username'
}
